import { useRouter } from 'next/router';

const useQueryParam = (paramName: string): string | false => {
    const router = useRouter();
    const searchParams = new URLSearchParams(router.asPath.split('?')[1]);

    // Check if the searchParams object contains the paramName
    if (searchParams.has(paramName)) {
        // Return the value of the paramName if it exists
        return searchParams.get(paramName) || '';
    } else {
        // Return false if the paramName does not exist
        return false;
    }
};

export default useQueryParam;
